import React from 'react';

import './Navigation.css';
import { Link } from 'react-router-dom';

const Navigation = () => {
	return (
		<div className="navigationCont">
			<div className="navigation">
				<h2>Brand Store</h2>
				<ul className="navList">
					<li>
						<Link to={'/Wyndham'}>Wyndham</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/Wyndham/HowardJohnson'}>Howard Johnson</Link>
							</li>
							<li>
								<Link to={'/Wyndham/Ramada'}>Ramada</Link>
							</li>
							<li>
								<Link to={'/Wyndham/HawthornSuites'}>Hawthorn Suites</Link>
							</li>
							<li>
								<Link to={'/Wyndham/DaysInn'}>Days Inn</Link>
							</li>
							<li>
								<Link to={'/Wyndham/WyndhamHotels'}>Wyndham</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/TheFern'}>The Fern</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/TheFern/TheFernSubBrand'}>TheFern SubBrand</Link>
							</li>
							<li>
								<Link to={'/TheFern/Beacon'}>Beacon</Link>
							</li>
							<li>
								<Link to={'/TheFern/ZincJourney'}>Zinc Journey</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/Inde'}>Inde Hotels & Resorts</Link>
					</li>
					<li>
						<Link to={'/TheClarks'}>The Clarks</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/TheClarks/ClarksExotica'}>Clarks Exotica</Link>
							</li>
							<li>
								<Link to={'/TheClarks/TheClarksSubBrand'}>The Clarks Sub Brand</Link>
							</li>
							<li>
								<Link to={'/TheClarks/ClarksInnSuites'}>Clarks Inn Suites</Link>
							</li>
							<li>
								<Link to={'/TheClarks/ClarksInn'}>Clarks Inn</Link>
							</li>
							<li>
								<Link to={'/TheClarks/ClarksSafari'}>Clarks Safari</Link>
							</li>
							<li>
								<Link to={'/TheClarks/ClarksInnExpress'}>Clarks Inn Express</Link>
							</li>
							<li>
								<Link to={'/TheClarks/ClarksCollection'}>Clarks Collection</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/CGHEarth'}>CGH</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/CGHEarth/CGHEarthExperienceHotels'}>CGH Earth Experience Hotels</Link>
							</li>
							<li>
								<Link to={'/CGHEarth/CGHEarthWellness'}>CGH Earth Wellness</Link>
							</li>
							<li>
								<Link to={'/CGHEarth/CGHEarthSaha'}>CGH Earth Saha</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/DlsHotels'}>Dls Hotels</Link>
					</li>
					<li>
						<Link to={'/WelcomHeritage'}>Welcom Heritage</Link>
					</li>
					<li>
						<Link to={'/LemonTreeHotel'}>Lemon Tree Hotel</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/LemonTreeHotel/Aurika'}>Aurika</Link>
							</li>
							<li>
								<Link to={'/LemonTreeHotel/LemonTreePremier'}>Lemon Tree Premier</Link>
							</li>
							<li>
								<Link to={'/LemonTreeHotel/LemonTreeHotels'}>Lemon Tree Hotels</Link>
							</li>
							<li>
								<Link to={'/LemonTreeHotel/RedFoxHotels'}>Red Fox Hotels</Link>
							</li>
							<li>
								<Link to={'/LemonTreeHotel/KeysSelectHotels'}>Keys Select Hotels</Link>
							</li>
							<li>
								<Link to={'/LemonTreeHotel/KeysPrima'}>Keys Prima Hotels</Link>
							</li>
							<li>
								<Link to={'/LemonTreeHotel/KeysLite'}>Keys Lite Hotels</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/CygnettHotels&Resorts'}>Cygnett</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/CygnettHotels&Resorts/CygnettInn'}>Cygnett Inn</Link>
							</li>
							<li>
								<Link to={'/CygnettHotels&Resorts/CygnettStyle'}>Cygnett Style</Link>
							</li>
							<li>
								<Link to={'/CygnettHotels&Resorts/CozzetHotels'}>Cozzet</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/SaffronStays'}>Saffron Stays</Link>
					</li>
					<li>
						<Link to={'/Sarovar'}>Sarovar</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/Sarovar/GoldenTulip'}>Golden Tulip</Link>
							</li>
							<li>
								<Link to={'/Sarovar/Hometel'}>Hometel</Link>
							</li>
							<li>
								<Link to={'/Sarovar/RoyalTulip'}>Royal Tulip</Link>
							</li>
							<li>
								<Link to={'/Sarovar/SarovarPortico'}>Sarovar Portico</Link>
							</li>
							<li>
								<Link to={'/Sarovar/SarovarPremiere'}>Sarovar Premiere</Link>
							</li>
							<li>
								<Link to={'/Sarovar/TulipInn'}>Tulip Inn</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/IHG'}>IHG Hotels & Resort</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/IHG/Kimpton'}>Kimpton</Link>
							</li>
							<li>
								<Link to={'/IHG/Intercontinental'}>Intercontinental</Link>
							</li>
							<li>
								<Link to={'/IHG/HolidayInn'}>Holiday Inn</Link>
							</li>
							<li>
								<Link to={'/IHG/Voco'}>Voco</Link>
							</li>
							<li>
								<Link to={'/IHG/HotelIndigo'}>Hotel Indigo</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/Brij'}>Brij</Link>
					</li>
					<li>
						<Link to={'/PoloTowers'}>Polo Towers</Link>
					</li>
					<li>
						<Link to={'/Tamara'}>Tamara</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/Tamara/TamaraResort'}>Tamara Resort</Link>
							</li>
							<li>
								<Link to={'/Tamara/OByTamara'}>O By Tamara</Link>
							</li>
							<li>
								<Link to={'/Tamara/LilacHotel'}>Lilac Hotel</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/PalazzoVersace'}>Palazzo Versace</Link>
					</li>
					<li>
						<Link to={'/LeRoi'}>Le Roi</Link>
					</li>
					<li>
						<Link to={'/Kingston'}>Kingston</Link>
					</li>
					<li>
						<Link to={'/Timbertale'}>Timbertale</Link>
					</li>
					<li>
						<Link to={'/BestWestern'}>Best Western</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/BestWestern/Business'}>Business</Link>
							</li>
							<li>
								<Link to={'/BestWestern/Leisure'}>Leisure</Link>
							</li>
							<li>
								<Link to={'/BestWestern/Pilgrimage'}>Pilgrimage</Link>
							</li>
							<li>
								<Link to={'/BestWestern/BestWesternBasic'}>BestWesternBasic</Link>
							</li>
							<li>
								<Link to={'/BestWestern/BestWesternPlus'}>BestWesternPlus</Link>
							</li>
							<li>
								<Link to={'/BestWestern/SureStay'}>SureStay</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/Ascott'}>Ascott</Link>
						<ul className="subNavList">
							<li>
								<Link to={'/Ascott/CloseToMetro'}>CloseToMetro</Link>
							</li>
							<li>
								<Link to={'/Ascott/PoolsideBliss'}>Poolside Bliss</Link>
							</li>
							<li>
								<Link to={'/Ascott/KidFriendlyActivities'}>Kid Friendly Activities</Link>
							</li>
						</ul>
					</li>
					<li>
						<Link to={'/Majestic'}>Majestic</Link>
					</li>
					<li>
						<Link to={'/HongKongDisneyLand'}>Hong Kong DisneyLand</Link>
					</li>
					<li>
						<Link to={'/Taj'}>Taj</Link>
					</li>
					<li>
						<Link to={'/Sterling'}>Sterling</Link>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default Navigation;
